import { render, staticRenderFns } from "./UserInvitationsListView.vue?vue&type=template&id=3156d665&scoped=true&"
import script from "./UserInvitationsListView.vue?vue&type=script&lang=ts&"
export * from "./UserInvitationsListView.vue?vue&type=script&lang=ts&"
import style0 from "./UserInvitationsListView.vue?vue&type=style&index=0&id=3156d665&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3156d665",
  null
  
)

export default component.exports